/* oxlint-disable @typescript-eslint/no-unused-vars */

import { CustomButton } from '@/shared/ui/components';
import { ExclamationCircleFilled } from '@ant-design/icons';
import React from 'react';
import { useUndoMarkAddressed } from './useUndoMarkAddressed';
import './markAddressedStudy.scss';

export interface UndoMarkAddressedProps {
  studyId: string;
}

/**
 * Renders the banner shown on a study whose flagged issue was ignored, explaining that the issue below is the most recent one detected before it. Provides an Undo button wired to onClickUndo from useUndoMarkAddressed for the given study, showing the hook's loading flag while the undo request is in flight.
 *
 * @param studyId - Identifier of the study whose mark-addressed action can be undone.
 * @returns The undo mark-addressed banner element.
 */
const UndoMarkAddressed = ({ studyId }: UndoMarkAddressedProps) => {
  const { loading, onClickUndo } = useUndoMarkAddressed({ studyId });

  return (
    <div className="undo-mark-addressed-tag">
      <div className="undo-mark-addressed-tag__content">
        <ExclamationCircleFilled color="#F58F0A" />
        <div>
          Flagged issue has been ignored for this study. The issue below is the most recent one
          detected before it.
        </div>
      </div>
      <CustomButton
        loading={loading}
        onClick={onClickUndo}
        className="undo-mark-addressed-tag__button"
        size="small"
        type="tertiary"
        style="default"
      >
        Undo
      </CustomButton>
    </div>
  );
};

export default UndoMarkAddressed;
